import React, { useState } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { TiTick } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import BannerSideImage from "../../assets/images/neural-network-circuit.webp";
import CMSDevelopmentSideImage from "../../assets/images/cross-platform-application-compatible-on-different-devices.webp";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperComponent from "../../components/SwiperComponent";
import "../../App.css";
import CustomBanner from "../../components/CustomBanner";
import FAQSection from "../../components/FAQSection";
import ourVision from "../../assets/images/multi-tasking-ai-agent.avif";
import ourMission from "../../assets/images/chatbot-conversing-with-ai-agent.avif";
import CustomTabs from "../../components/CustomTabs";
import { techStacks } from "./TabsTechStacks";
import { routes } from "../../config/utilities/utils.constant";
import { Link } from "react-router-dom";
import TechStackAnimation from "../../components/TechStackAnimation";
import { techStackAnimatedIcons } from "./TabsTechStacks";
import { faqData, process } from "./AIIntegrationsAndChatbotsData";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";

const AIIntegrationsAndChatbots = () => {
  return (
    <>
      <Head>
        <title> Integrate LLMs, AI agents and chatbots into your apps </title>
        <meta
          name="description"
          content="Utilize AI responsibly as an auxiliary tool for enhancing productivity, user experience, and complimenting capabilities of human resources in complex use-cases."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/ai-integrations-and-chatbots"
        />
      </Head>
      <CustomBanner
        svgImg={BannerSideImage}
        svgWidth="w-[8rem] mobSmallScreen:w-[10rem] mobMediumScreen:w-[10rem] screen-400:w-[15rem] mobileLargeScreen:w-[12rem] xs:w-[16rem] sm:w-[18rem] md:w-[16rem]  lg:w-[19rem] xl:w-[25rem] "
        svgPosition="-bottom-[2.7rem] mobMediumScreen:-bottom-[4rem] screen-400:-bottom-[3.5rem]   mobileLargeScreen:-bottom-[3.5rem] sm:-bottom-16 md:top-[74%] lg:top-[69%]  xl:top-[59%]  "
        imgAlt="Artificial neural network, in the shape of human brain, with neurons and connecting nodes."
      >
        <div>
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px] leading-[1] font-bold "
          >
            <div>AI Integrations</div>
            <div>and Chatbots</div>
          </motion.h1>
        </div>

        <ul className="space-y-2 md:w-10/12 2xl:w-full">
          <li className="flex items-start   text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 ">
              <TiTick />
            </span>
            <span className="text-[15px] md:text-base">
              Optimize and fine-tune advanced AI models for specialized industry
              applications.
            </span>
          </li>
          <li className="flex items-start  text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 ">
              <TiTick />
            </span>
            <span className="text-[15px] md:text-base">
              Develop intelligent chatbots for enhanced customer satisfaction
              and convenient support.
            </span>
          </li>
          <li className="flex items-start  text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 ">
              <TiTick />
            </span>
            <span className="text-[15px] md:text-base">
              Leverage pre-built AI services, including generative AI and voice,
              through expert API integration.
            </span>
          </li>
        </ul>
      </CustomBanner>
      <div className=" space-y-20 md:space-y-32 mb-32">
        <div className="container ">
          <section className=" ">
            {/* Desktop Animation - show only on large screens and up */}
            <div className="hidden md:block">
              <TechStackAnimation.TechStackDesktopAnimation
                techStackAnimatedIcons={techStackAnimatedIcons}
              />
            </div>

            {/* Mobile Animation - show only on small and medium screens */}
            <div className="block md:hidden">
              <TechStackAnimation.TechStackMobileAnimation
                techStackAnimatedIcons={techStackAnimatedIcons}
              />
            </div>
          </section>
        </div>
        <div className=" bg-gray-50 py-20 md:py-32 px-5">
          <div className="  my-5 space-y-14 md:space-y-20  container ">
            <div className="flex flex-col md:flex-row rounded-xl overflow-hidden text-dark shadow-md   ">
              <div className="w-full md:w-6/12">
                <img
                  src={ourVision}
                  alt="An Ai agent which can multi-task such as handle emails and other prioritize daily tasks."
                  className="h-full w-full"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-6 xl:px-7 bg-[#f3ebfa] h[30rem]">
                <div className="md:my-4 space-y-4 ">
                  <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.3 }}
                    className="text-2xl md:text-3xl font-bold"
                  >
                    Our AI Integration Capabilities
                  </motion.h2>
                  <ul className="space-y-2 text-base md:text-lg">
                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        We integrate leading pre-built AI models from major
                        cloud providers like Azure, AWS, and Google Cloud. Our
                        expert API integrations seamlessly deploy advanced AI
                        into your core business operations.
                      </p>
                    </li>

                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        Apptalyst customizes pre-trained AI models for enhanced
                        accuracy and specialized application. This enables AI to
                        provide precise, context-aware outcomes for specific
                        business challenges and data sets.
                      </p>
                    </li>

                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        We ensure all AI integrations are built for
                        enterprise-grade scalability and unwavering reliability.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="flex flex-col md:flex-row-reverse rounded-xl overflow-hidden text-dark shadow-md  ">
              <div className="w-full md:w-6/12">
                <img
                  src={ourMission}
                  alt="An intelligent chatbot assisting user by answering a question and directing user to the correct page."
                  className="h-full w-full"
                />
              </div>
              <div className="w-full md:w-6/12 flex flex-col justify-center p-4 md:px-6 xl:px-7  bg-[#f3ebfa] h[30rem] ">
                <div className="  md:my-4  space-y-4">
                  <motion.h2
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.3 }}
                    className="text-2xl md:text-3xl font-bold"
                  >
                    Our Chatbot Solutions
                  </motion.h2>
                  <ul className="space-y-2 text-base md:text-lg">
                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        We integrate and tailor leading chatbot platforms and
                        conversational AI models to meet your specific business
                        requirements.
                      </p>
                    </li>

                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        Deploy our chatbots to automate routine inquiries and
                        provide instant, 24/7 support to your customers. This
                        frees your human agents to focus on high-value
                        interactions and boost and operational efficiency.
                      </p>
                    </li>

                    <li className="flex items-start space-x-2">
                      <span className="text-dark bg-[#FFC067] rounded-full p-0.5 mt-1">
                        <TiTick />
                      </span>
                      <p className="text-base leading-[1.625rem]">
                        Our chatbot solutions integrate effortlessly with your
                        existing CRM, ticketing systems, and communication
                        platforms.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <FAQSection faqData={faqData} />
        </div>
      </div>
    </>
  );
};

export default AIIntegrationsAndChatbots;
